import { Directive, ElementRef } from '@angular/core';
import { SettingService } from '../services/setting.service';

@Directive({
    selector: 'img[logo]',
    exportAs: 'logo',
    standalone: false
})
export class LogoDirective {

  constructor(private element: ElementRef<HTMLImageElement>,
              private setting: SettingService) {
    this.element.nativeElement.src = this.setting.logo;
  }
}